import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const BalanceSheetPreviewRecord = Record({
  equity: 0,
  asset: 0,
  liability: 0,
  totalCash: 0,
  netAssets: 0,
  accountNames: [],
});

export default class BalanceSheetPreview extends BalanceSheetPreviewRecord {
  static deserialize(jsonObject = {}) {
    if (typeof jsonObject === 'undefined' || jsonObject === null) {
      return undefined;
    }

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject), {});

    return new BalanceSheetPreview(hydrated);
  }
}
